import {
  ButtonNavbar,
  classNames,
} from 'libs/growth-platform-brand-system-v2/src';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { morphism } from 'morphism';
import React from 'react';
import { schemaDatoButton } from '../../morphismSchema/schemaDatoButton';

export const ButtonsHeader = ({ headerButtons, locale, className }: any) => {
  return (
    <ul
      className={classNames(
        'ButtonsHeader',
        'gap-12 list-none h-full',
        className,
        'items-center content-center',
      )}
    >
      {headerButtons &&
        headerButtons?.map((btn: any, key: number) => {
          const cta = morphism(schemaDatoButton, {
            ...btn,
            locale,
          });
          return (
            <li key={key}>
              <ButtonTracking
                component={ButtonNavbar}
                section="header_headerButton"
                index={key}
                labelTracking={cta.title}
                {...morphism(schemaDatoButton, {
                  ...btn,
                  paddingIsDisabled: true,
                  locale,
                })}
                className={classNames(
                  'whitespace-nowrap',
                  key > 0 && 'hidden xl:block', // keep only the first button for mobile. To refacto later with maybe a MobileButtons option in Dato
                )}
              />
            </li>
          );
        })}
    </ul>
  );
};
